import { getNationsText, isAllNations, nations, parseSelectedNations } from 'utils/topicNations';

interface TopicNationFlagsProps {
  mySelectedCountries?: string | null;
}

const TopicNationFlags = ({ mySelectedCountries }: TopicNationFlagsProps) => {
  const selectedNations = parseSelectedNations(mySelectedCountries);
  const nationsText = isAllNations(selectedNations) ? 'All nations of the UK' : getNationsText(selectedNations);

  return (
    <div
      className='d-flex align-items-center topic-nation-flags'
      role='img'
      aria-label={nationsText}
      data-tooltip-id='general-tooltip'
      data-tooltip-content={nationsText}
    >
      {nations
        .filter(({ field }) => selectedNations.includes(field))
        .map(({ field }) => (
          <span key={field} className={`topic-nation-flag rounded-circle label-${field.toLowerCase()}`} />
        ))}
    </div>
  );
};

export default TopicNationFlags;
